export default __webpack_public_path__ + "static/media/DOLNY_PASEK.98511d43.png";